import React from "react";
import { Box, Typography } from "@material-ui/core";
import { ActionLink, ExperienceCancellationPolicy, onEnter } from "halifax";
import {
  useCheckoutState,
  useCheckoutStateSelector as useSelector,
} from "@capone/checkout";

import "./styles.scss";
import {
  EXPERIENCE_REVIEW_HEADING_TEXT,
  EXPERIENCE_REVIEW_SUBTITLE_TEXT,
} from "./textConstants";
import {
  TravelerSelection,
  ContactInfo,
  PriceBreakdown,
  ExperienceSummaryPanel,
} from "..";
import { ExperiencesSelectors } from "../../state/selectors";
import {
  ADDITIONAL_DETAILS,
  CANCELLATION_POLICY,
  CHANGE_CTA_TEXT,
} from "../../../common/textConstants";
import { ExperiencesAdditionalDetailsSelectors } from "../../../../checkout";
import { AdditionalDetailsCompleted } from "../AdditionalDetails";
import { Event, TEvent } from "../../state/events";
import { ExperiencesMachineContext } from "../../state/types";

export const MobileTripReview = () => {
  const [, send] = useCheckoutState<TEvent, ExperiencesMachineContext>();

  const expShop = useSelector(ExperiencesSelectors.getExperienceShop);

  const priceBreakdown = useSelector(
    ExperiencesSelectors.getExperiencePriceBreakdown
  );
  const hasCompletedAdditionalDetailsStep = useSelector(
    ExperiencesAdditionalDetailsSelectors.getHasCompletedAdditionalDetailsStep
  );

  return (
    <Box className="experiences-checkout-review">
      <Typography className="mobile-header-title">
        {EXPERIENCE_REVIEW_HEADING_TEXT}
      </Typography>
      <Typography className="mobile-header-subtitle">
        {EXPERIENCE_REVIEW_SUBTITLE_TEXT}
      </Typography>
      <hr className="heading-rule" />

      <ExperienceSummaryPanel displayChangeBtn />
      <TravelerSelection isMobile />
      <ContactInfo isMobile />

      {hasCompletedAdditionalDetailsStep && (
        <Box className="mobile-review-additional-details-container">
          <Typography className="mobile-review-additional-details-title">
            {ADDITIONAL_DETAILS}
          </Typography>
          <AdditionalDetailsCompleted />
          <ActionLink
            className="edit-button"
            content={
              <Typography className="action-link-text">
                {CHANGE_CTA_TEXT}
              </Typography>
            }
            label={CHANGE_CTA_TEXT}
            onClick={() => send(Event.GO_TO_ADDITIONAL_DETAILS)}
            onKeyDown={(e) =>
              onEnter(e, () => send(Event.GO_TO_ADDITIONAL_DETAILS))
            }
          />
        </Box>
      )}

      {expShop?.cancellationPolicy && (
        <Box className="mobile-review-cancellation-policy-container">
          <Typography className="mobile-review-cancellation-policy-title">
            {CANCELLATION_POLICY}
          </Typography>
          <ExperienceCancellationPolicy
            cancellationPolicy={expShop.cancellationPolicy}
            selectedDate={priceBreakdown?.date}
            selectedTime={priceBreakdown?.startTime}
          />
        </Box>
      )}
      <PriceBreakdown isMobile />
    </Box>
  );
};
